module.exports = __webpack_public_path__ + "img/expertise_cards.6d62c1a2.png";